import { useEffect } from 'react';
import { TraderList } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useTraderLists() {
  const traderLists = useAxios(
    (axios, signal) =>
      axios.request<TraderList[]>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shippers/traderLists`,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    traderLists.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return traderLists;
}

export type TsoConfigRequest = ReturnType<typeof useTraderLists>;
